import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import {
  Collapse,
  Form,
  Input,
  Select,
  message,
  InputNumber,
  Layout,
} from "antd";
import {
  indexesGetAllIndexes,
  indexesUpdateIndex,
  indexesDeleteIndex,
  indexformatGetFormats,
} from "../../store/actions";
import Breadcrumb from "../../components/Breadcrumb";
// import "./style.css";
import ExportCSV from "../../components/Common/ExportCSV";
import { IndexTagOptions, IndexTagRenderer } from "./CreateIndexes";
import IndexTable from "../../components/IndexManagement/IndexView/IndexTable";

const { Option } = Select;
const { Panel } = Collapse;

const exportColumns = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Format",
    dataIndex: "format",
  },
  {
    title: "Wildcard",
    dataIndex: "wildcard",
  },
  {
    title: "Order",
    dataIndex: "order",
  },
  {
    title: "Required",
    dataIndex: "required",
  },
  {
    title: "Default Index",
    dataIndex: "defaultIndex",
  },
  {
    title: "Editable",
    dataIndex: "editable",
  },
  {
    title: "Available In IS",
    dataIndex: "availableInIS",
  },
  {
    title: "Tags",
    dataIndex: "tags",
  },
  {
    title: "Created by",
    dataIndex: "create_by",
  },
  {
    title: "Created at",
    dataIndex: "create_at",
  },
  {
    title: "Updated by",
    dataIndex: "update_by",
  },
  {
    title: "Updated at",
    dataIndex: "update_at",
  },
  {
    title: "Operation",
    dataIndex: "operation",
  },
]

class IndexView extends Component {
  constructor() {
    super();
    this.state = {
      searchText: "",
      searchedColumn: "",
      currentIndexes: [],
      editingKey: null,
      updateRecord: {
        name: undefined,
        type: undefined,
      },
      dateformats: [],
    };
  }

  async componentDidMount() {
    this.getIndexes();
    const dateTypes = await this.props.indexformatGetFormats();
    this.setState({
      dateformats: dateTypes,
    });
  }

  generateInputElement = (dataIndex) => {
    switch (dataIndex) {
      case "name":
        return (
          <Input
            value={this.state.updateRecord[dataIndex]}
            onChange={(e) => {
              const updateRec = { ...this.state.updateRecord };
              updateRec[dataIndex] = e.target.value;
              this.setState({
                updateRecord: updateRec,
              });
            }}
            placeholder="Field Name"
          />
        );
      case "format":
        return this.state.updateRecord.type !== "Date" ? (
          <Input
            value={this.state.updateRecord[dataIndex]}
            onChange={(e) => {
              const updateRec = { ...this.state.updateRecord };
              updateRec[dataIndex] = e.target.value;
              this.setState({
                updateRecord: updateRec,
              });
            }}
            placeholder="Format"
          />
        ) : (
          <Select
            value={this.state.updateRecord[dataIndex]}
            style={{ width: "100%" }}
            onChange={(e) => {
              const updateRec = { ...this.state.updateRecord };
              updateRec[dataIndex] = e;
              this.setState({
                updateRecord: updateRec,
              });
            }}
            placeholder="Format"
          >
            {this.state.dateformats.map((elem, index) => (
              <Option key={index} value={elem.default}>
                {elem.default}
              </Option>
            ))}
          </Select>
        );
      case "type":
        return (
          <Select
            value={this.state.updateRecord[dataIndex]}
            onChange={(e) => {
              const updateRec = { ...this.state.updateRecord };
              if (
                (updateRec[dataIndex] !== "Date" && e === "Date") ||
                (updateRec[dataIndex] === "Date")  &&  (e !== "Date")
              ) {
                updateRec.format = undefined;
              }
              updateRec[dataIndex] = e;
              if (updateRec[dataIndex] !== "Text") {
                updateRec.wildcard = 0;
              }
              this.setState({
                updateRecord: updateRec,
              });
            }}
          >
            <Option value="Boolean">Boolean</Option>
            <Option value="Date">Date</Option>
            <Option value="Integer">Number</Option>
            <Option value="Double Number">Double Number</Option>
            <Option value="Text">Text</Option>
            <Option value="Long Text">Long Text</Option>
          </Select>
        );
      case "wildcard":
        return (
          <InputNumber
            placeholder="Wildcard"
            style={{ width: "100%" }}
            value={this.state.updateRecord[dataIndex]}
            disabled={this.state.updateRecord.type !== "Text"}
            min={0}
            precision={0}
            step={1}
            onChange={(e) => {
              const updateRec = { ...this.state.updateRecord };
              updateRec[dataIndex] = e;
              this.setState({
                updateRecord: updateRec,
              });
            }}
          />
        );
      case "order":
        return (
          <InputNumber
            placeholder="Order"
            style={{ width: "100%" }}
            value={this.state.updateRecord[dataIndex]}
            min={0}
            precision={0}
            step={1}
            onChange={(e) => {
              const updateRec = { ...this.state.updateRecord };
              updateRec[dataIndex] = e;
              this.setState({
                updateRecord: updateRec,
              });
            }}
          />
        );
      case "required":
      case "defaultIndex":
      case "editable":
      case "availableInIS":
        return (
          <Select
            value={this.state.updateRecord[dataIndex]}
            onChange={(e) => {
              const updateRec = { ...this.state.updateRecord };
              updateRec[dataIndex] = e;
              this.setState({
                updateRecord: updateRec,
              });
            }}
          >
            <Option value>True</Option>
            <Option value={false}>False</Option>
          </Select>
        );
      case "tags":
        return (
          <Select
            mode="tags"
            showArrow
            tagRender={IndexTagRenderer}
            value={this.state.updateRecord[dataIndex]}
            onChange={(e) => {
              const updateRec = { ...this.state.updateRecord };
              updateRec[dataIndex] = e;
              this.setState({
                updateRecord: updateRec,
              });
            }}
            style={{ width: "100%" }}
            options={IndexTagOptions}
          />
        );
      default:
        return null;
    }
  };

  EditableCell = ({
    editing,
    dataIndex,
    title,
    record,
    index,
    children,
    ...restProps
  }) => {
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            style={{
              margin: 0,
            }}
          >
            {this.generateInputElement(dataIndex)}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  isEditing = (record) => {
    // console.log(record._id,'record',this.state.editingKey)
    return record._id === this.state.editingKey;
  };

  edit = (record) => {
    this.setState({ updateRecord: { ...record }, editingKey: record._id });
  };

  cancel = () => {
    this.setState({ editingKey: null }, () => console.log(this.state));
  };

  save = async () => {
    if (this.validate()) {
      const response = await this.props.indexesUpdateIndex(
        this.state.updateRecord
      );
      if (response) {
        const recordIndex = this.state.currentIndexes.findIndex(
          (elem) => elem._id === this.state.updateRecord._id
        );
        if (recordIndex !== -1) {
          let cindexes = [...this.state.currentIndexes];
          cindexes[recordIndex] = { ...this.state.updateRecord };
          this.setState({
            currentIndexes: cindexes,
            updateRecord: {
              name: undefined,
              type: undefined,
            },
            editingKey: null,
          });
        }
      } else {
        await this.getIndexes();
        this.setState({
          updateRecord: {
            name: undefined,
            type: undefined,
          },
          editingKey: null,
        });
      }
    }
  };

  delete = async () => {
    const result = await this.props.indexesDeleteIndex(
      this.state.updateRecord._id
    );
    if (result) {
      const currentIndexes = [...this.state.currentIndexes];
      const recordIndex = this.state.currentIndexes.findIndex(
        (elem) => elem._id === this.state.updateRecord._id
      );
      if (recordIndex !== -1) {
        currentIndexes.splice(recordIndex, 1);
        this.setState({
          currentIndexes: currentIndexes,
          updateRecord: {
            name: undefined,
            type: undefined,
          },
          editingKey: null,
        });
      }
    }
  };

  validate = () => {
    if (
      this.state.updateRecord.name === undefined ||
      this.state.updateRecord.name.length === 0
    ) {
      message.error("Index Name cannot be empty");
      return false;
    }
    if (this.state.updateRecord.type === undefined) {
      message.error("Index Type cannot be empty");
      return false;
    }
    if (
      this.state.updateRecord.type === "Date" &&
      this.state.updateRecord.format === undefined
    ) {
      message.error("Please Select Index format");
      return false;
    }
    if (
      this.state.currentIndexes.findIndex((elem) => {
        return (
          elem._id !== this.state.updateRecord._id &&
          this.state.updateRecord.name.toUpperCase() === elem.name.toUpperCase()
        );
      }) !== -1
    ) {
      message.error("Index Name already exist");
      return false;
    }
    return true;
  };

  getIndexes = async () => {
    const result = await this.props.indexesGetAllIndexes();
    if (!result.error) {
      this.setState({ currentIndexes: result.data });
    }
  };

  render() {
    return (
      <>
        <Layout>
          <div className="container_aa">
            <h3>Index View and Update</h3>
            <Breadcrumb
              routes={[
                { path: "/", breadcrumbName: "Dashboard" },
                {
                  path: "/index/view",
                  breadcrumbName: "Index View and Update",
                },
              ]}
            />
          </div>
          <div>
            <div className="container_ab">
              <Collapse
                defaultActiveKey={["1", "2"]}
                expandIconPosition="right"
              >
                <Panel header="Manage Indexes" key="1">
                  <div className="container_style_1_b">
                    <div className="is_table_3">
                      <ExportCSV
                        csvData={this.state.currentIndexes}
                        fileName="Manage Indexes"
                        columnNames={exportColumns}
                      />
                      <IndexTable
                        editableCell={this.EditableCell}
                        save={this.save}
                        deletefn={this.delete}
                        cancel={this.cancel}
                        edit={this.edit}
                        isEditing={this.isEditing}
                        editingKey={this.state.editingKey}
                        dataSource={this.state.currentIndexes}
                      />
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div>
          </div>
        </Layout>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  indexesGetAllIndexes: () => dispatch(indexesGetAllIndexes()),
  indexesUpdateIndex: (data) => dispatch(indexesUpdateIndex(data)),
  indexesDeleteIndex: (id) => dispatch(indexesDeleteIndex(id)),
  indexformatGetFormats: () => dispatch(indexformatGetFormats()),
});

export default connect(null, mapDispatchToProps)(IndexView);
